import React from 'react';
import PropTypes from 'prop-types';

const DepartmentInformationBillingUnit = ({
    billingName, 
    organizationNumber, 
    invoiceAsEHF, 
    invoiceEmailAddress, 
    invoiceEhfLabel, 
    orgNoLabel,
    heading,
    sendInvoiceEmailLabel,
    invoiceAsEHFYesText,
    invoiceAsEHFNoText
} ) => (
    <div>
        {billingName && <strong className='billing-name'>{billingName}</strong>}
        {organizationNumber && <p>
            <span className='billing-line'>{orgNoLabel && <span className='billing-label'>{orgNoLabel}:</span>}{organizationNumber}</span>
        </p>}
        {invoiceEmailAddress && (
            <p>
                <span className='billing-line flex-wrap'>
                    {sendInvoiceEmailLabel && <span className='billing-label'>{sendInvoiceEmailLabel}:</span>}{invoiceEmailAddress &&<a data-name={heading} href={`mailto:${invoiceEmailAddress}`}>{invoiceEmailAddress}</a>}
                </span>
            </p>
        )}
        <p>
            <span className='billing-line'>
                {invoiceEhfLabel && <span className='billing-label'>{invoiceEhfLabel}:</span>}<span>{invoiceAsEHF ? invoiceAsEHFYesText : invoiceAsEHFNoText}</span>
            </span>
        </p>
    </div>
);

DepartmentInformationBillingUnit.propTypes = ({
    billingName: PropTypes.string,
    organizationNumber: PropTypes.string,
    invoiceAsEHF: PropTypes.bool.isRequired,
    invoiceAsEHFYesText: PropTypes.string,
    invoiceAsEHFNoText: PropTypes.string,
    invoiceEmailAddress: PropTypes.string,
    invoiceEhfLabel: PropTypes.string,
    orgNoLabel: PropTypes.string,
    invoiceEhfLinkText: PropTypes.string,
    heading: PropTypes.string,
    sendInvoiceEmailLabel: PropTypes.string
});

export default DepartmentInformationBillingUnit;



// WEBPACK FOOTER //
// ./src/components/DepartmentInformationPage/DepartmentInformationBillingUnit.jsx